import React from "react";
import { AimOutlined, BarChartOutlined, DashboardOutlined, ExclamationOutlined } from "@ant-design/icons";
import { GiAmericanFootballHelmet } from "react-icons/gi";
import "./HelmetImpact.css";

const DATA_TYPES = [
  { label: "Volume", icon: <BarChartOutlined />, tone: "green" },
  { label: "Severity", icon: <DashboardOutlined />, tone: "orange" },
  { label: "Location", icon: <AimOutlined />, tone: "blue" },
  { label: "Alerts", icon: <ExclamationOutlined />, tone: "red" },
];

const CS_EMAIL = "cs@whistleperformance.ai";

/** The popover content of the disabled Helmet Impact tab, for a football team without a helmet integration. */
export function HelmetImpactPitch({ teamName }: { teamName: string }) {
  const subject = encodeURIComponent(`Helmet Impact setup for ${teamName}`);
  const body = encodeURIComponent(
    `Hi,\n\nWe would like to set up Helmet Impact for ${teamName}. Please tell us the next steps.\n\nThanks`
  );
  return (
    <div className="helmet-pitch">
      <div className="helmet-pitch-head">
        <GiAmericanFootballHelmet className="helmet-pitch-icon" />
        <div>
          <div className="helmet-pitch-title">Helmet Impact data isn't set up yet</div>
          <div className="helmet-pitch-subtitle">Connect your team's Riddell helmets to see head impact data.</div>
        </div>
      </div>
      <div className="helmet-pitch-cards">
        {DATA_TYPES.map(({ label, icon, tone }) => (
          <div key={label} className="helmet-pitch-card">
            <span className={`helmet-pitch-card-icon helmet-pitch-card-icon--${tone}`}>{icon}</span>
            {label}
          </div>
        ))}
      </div>
      <div className="helmet-pitch-contact">
        Contact <a href={`mailto:${CS_EMAIL}?subject=${subject}&body=${body}`}>{CS_EMAIL}</a> to get started
      </div>
    </div>
  );
}
